import {Card} from 'components';
import {AuthSource} from 'enums';

import {Actions, IntegrationContent, SourceLabel} from '../IntegrationContent';

type Props = {
    integration: {
        source: AuthSource;
        credentials: any;
        data: any;
    };
    logo: string;
    sourceLabel: string;
    isEditable: boolean;
    isSalesforceIntegration: boolean;
    isDeviceIntegration: boolean;
    isAppointmentsIntegration: boolean;
    onEdit: () => void;
    onDelete: () => void;
};

export const IntegrationsCard: React.FC<Props> = ({
    integration, sourceLabel, logo, isEditable, isSalesforceIntegration, isDeviceIntegration, isAppointmentsIntegration, onEdit, onDelete
}: Props) => (
    <Card fullWidth={false} className='-sm:tw-hidden tw-flex tw-p-5'>
        <div className='tw-pr-4 tw-w-20 tw-flex-shrink-0'>
            <img src={logo} alt={sourceLabel} className='tw-w-full' />
        </div>
        <div className='tw-flex-1'>
            <div className='tw-flex tw-justify-between tw-items-center -sm:tw-my-1'>
                <SourceLabel label={sourceLabel} />
                <Actions isEditable={isEditable} onEdit={onEdit} onDelete={onDelete} />
            </div>
            <IntegrationContent
                integration={integration}
                isSalesforceIntegration={isSalesforceIntegration}
                isDeviceIntegration={isDeviceIntegration}
                isAppointmentsIntegration={isAppointmentsIntegration}
            />
        </div>
    </Card>
);